export default function dateFormatter(dateStr: string): string{
    const [day, month, year] = dateStr.split('/');
    return `${month}/${day}/${year}`;
}